import { callEndpoint } from '@api/v2'
import { ResponseMonitoringData } from '@shared/types/v2/monitoring'

/**
 * This function loads all monitoring data that is required to populate the monitoring dashboard
 */
export async function getMonitoringData(): Promise<ResponseMonitoringData> {
  return await callEndpoint('v2.Monitoring.getAllMonitoringDataService', undefined)
}
